module.exports = "/dist/895aadbff357be35ac8dd107c7975ee7.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800.woff
// module id = 136
// module chunks = 0